/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../../../common";
import type {
  MoarBaseMock,
  MoarBaseMockInterface,
} from "../../../../../../../../contracts/submodules/moar-locker/submodules/moar/contracts/mock/MoarBaseMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalToOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurnningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "DuplicatedMint",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrOperator",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferDeactive",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLocked",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferLockedByAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "LockTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "isApprovedOrOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "locked",
        type: "bool",
      },
    ],
    name: "lockTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "bool[]",
        name: "locks",
        type: "bool[]",
      },
    ],
    name: "lockTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transferDeactive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transferLocks",
    outputs: [
      {
        internalType: "enum MoarBase.LockStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type MoarBaseMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MoarBaseMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MoarBaseMock__factory extends ContractFactory {
  constructor(...args: MoarBaseMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<MoarBaseMock> {
    return super.deploy(
      admin,
      royaltyAddress,
      overrides || {}
    ) as Promise<MoarBaseMock>;
  }
  override getDeployTransaction(
    admin: PromiseOrValue<string>,
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(admin, royaltyAddress, overrides || {});
  }
  override attach(address: string): MoarBaseMock {
    return super.attach(address) as MoarBaseMock;
  }
  override connect(signer: Signer): MoarBaseMock__factory {
    return super.connect(signer) as MoarBaseMock__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MoarBaseMockInterface {
    return new utils.Interface(_abi) as MoarBaseMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MoarBaseMock {
    return new Contract(address, _abi, signerOrProvider) as MoarBaseMock;
  }
}
